import { DynamicInput, IDynamicInputOptions } from "../dynamic-input.model";
import { TextboxType } from "../textbox/textbox-type.enum";
import { NoConfirmComponent } from "./no-confirm.component";

export interface INoConfirm extends IDynamicInputOptions {
  type?: TextboxType;
  pageNumber?: number;
  adminValue?: string;
  validationId?: string;
  validationNote?: string;
  dataType?: string;
  autocomplete?: string;
}
export class NoConfirm extends DynamicInput implements INoConfirm {
  type: TextboxType;
  pageNumber: number;
  adminValue: string;
  validationId: string;
  validationNote: string;
  dataType: string;
  autocomplete: string;

  readonly controlType = "text";
  readonly componentType = NoConfirmComponent;

  constructor(options: INoConfirm = {}) {
    super(options);
    this.type = options.type || TextboxType.TEXT;
    this.pageNumber = options.pageNumber;
    this.adminValue = options.adminValue;
    this.validationId = options.validationId;
    this.validationNote = options.validationNote;
    this.dataType = options.dataType;
    this.autocomplete = options.autocomplete || "off";
  }
}
